import React, { useState } from "react";
import MyReservation from "./myReservation";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

const ResReservation2 = (props) => {

	const { t } = props
	const [heading, setHeading] = useState("");
	const [restaurantData, setRestaurantData] = useState(null);


	React.useEffect(() => {
		props.data.forEach((resort) => {
			if (resort.id == props.selectedResortId) {
				setHeading(resort.description)
				setRestaurantData(resort.restaurantsList)
			}
		})
	}, [])

	return (
		<div>
			<header class="inner-pages subpages">
				<a onClick={() => props.goBack()} class="button-back"></a>
				<div class="heading align-center">
					<p class="bold">{t('resReservation.heading2', { defaultValue: heading })}</p>
				</div>
			</header>
			<section class="widgets">
				<div class="row margin-bottom-2">
					<div class="col col-2">
						{
							restaurantData && restaurantData.map((restaurant) => {
								return (
									<>
										<a onClick={() => props.next(restaurant.id)} class="tile-sm thumbnails tile-container">
											<div class="thumb-img">
												{restaurant.image ?
													<img src={restaurant.image} />
													:
													<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.16 69.16" style={{ fill: "#010101" }}><defs></defs>
														<g id="Layer_1-2" data-name="Layer 1">
															<path class="cls-1" d="M37.44,35.84L4.14,69.16,.07,65.09,33.36,31.76l-2.03-2.04c-3.37-3.38-3.37-8.85,0-12.23L48.8,0l4.07,4.07-17.48,17.5c-1.13,1.12-1.13,2.95,0,4.08,0,0,0,0,0,0l2.04,2.04L56.95,8.15l4.07,4.08-19.52,19.54,2.03,2.04c1.13,1.13,2.95,1.13,4.07,0l17.49-17.5,4.06,4.08-17.48,17.5c-3.38,3.37-8.84,3.37-12.22,0l-2.03-2.04Zm-19.76,3.48l7.75-7.76c-2.8-4.21-3.16-9.58-.95-14.12L9.59,1.71c-2.19-2.19-5.75-2.19-7.94,0C.59,2.76,0,4.19,0,5.68c-.02,5.32,1.3,10.56,3.84,15.24,3.53,6.87,8.21,13.09,13.83,18.39Zm27.9,6.86c-2.82,0-5.58-.82-7.94-2.39l-4.9,4.9c4.89,2.2,10.25,3.17,15.61,2.8l16.56,17.61,4.2-3.95-18.83-19.82c-1.51,.54-3.1,.83-4.7,.85Z" />
														</g>
													</svg>
												}
											</div>
											<div class="thumb-text">
												<p class="thumb-heading">{restaurant.description}</p>
												{restaurant.shortDescription && <p>{restaurant.shortDescription}</p>}
											</div>
										</a>
									</>
								)
							})
						}
					</div>
				</div>
			</section>
		</div>
	)
}

const mapStateToProps = state => {
	return {
		installedAppVersion: state.store.installedAppVersion,
		installedAppBuildNo: state.store.installedAppBuildNo,
	}
}

export default connect(mapStateToProps, {})(withTranslation('translations')(ResReservation2));